import React from "react";
import { useState, useEffect } from "react";
import {
  inviteMembers,
  deleteMemberService,
} from "../../services/ActivePrograms";
import { showToastError, showToastSuccess } from "../../Utils/Helper";
import Loader from "../../commonComponent/Loader";
import { FiSearch } from "react-icons/fi";
import { AiOutlinePlus } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { MdDelete } from "react-icons/md";

import SquareAvatar from "../../commonComponent/SquareAvatar";
import DeleteModal from "../../commonComponent/DeleteModal";
import {
  getAllCareTeamMemberList,
} from "../../services/CareTeam";
import Navbar from "../header/Navbar";
import Sidebar from "../sidebar/Sidebar";
import AvatarPopover from "../../commonComponent/AvtarPopover";
import ApiConfig from "../../config/ApiConfig";
import AssignPatientModal from "./AssignPatientModal";
import { format, parseISO } from "date-fns";
import { useHover } from "../../customHook/useHover";

const TotalPatientList = (props) => {
  const [sortBy, setSortBy] = useState("");

  const [memberList, setMemberList] = useState([]);
  const [memberId, setMemberId] = useState("");
  const [askLoader, setAskLoader] = useState(false);
  const [dropDownList, setDropDownList] = useState(false);
  const [dropDown, setDropDown] = useState(false);
  const [isLoading, setLoader] = useState(true);
  const [open, setOpen] = useState(false);
  const [filterdata, setFilterData] = useState([]);
  // const [programMembers, setProgramMembers] = useState([]);
  const navigate = useNavigate();
  const programId = props.programId;
  const [selectedMembers, setSelectedMembers] = useState([]);
  const { hoveredUserId, handleMouseEnter, handleMouseLeave } = useHover();

  const [formValues, setFormValues] = useState([
    { email: "", first_name: "", last_name: "" },
  ]);
  const urlPattern = new RegExp(
    "((http|https)://)(www.)?" +
      "[a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]" +
      "{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)"
  );

  useEffect(() => {
    getPatients();
    setSortBy("")
  }, []);

  let dateSort = (filterdata1) => {
    setDropDownList(false);
    const result = filterdata1.sort(function (a, b) {
      a = new Date(a.dob);
      b = new Date(b.dob);
      return a > b ? -1 : a < b ? 1 : 0;
    });
    return result;
  };
  let nameSort = (filterdata1) => {
    setDropDownList(false);
    const result = filterdata1.sort(function compare(a, b) {
      const nameA = (a.full_name || "").toLowerCase().replace(/\s/g, "");
      const nameB = (b.full_name || "").toLowerCase().replace(/\s/g, "");
      // Custom comparison for undefined, null, empty string, and objects
      if (!nameA && !nameB) return 0; // Both are empty, treat them as equal
      if (!nameA) return 1; // Empty string, null, undefined, or object goes to the bottom
      if (!nameB) return -1;
      return nameA.localeCompare(nameB);
    });
    return result;
  };

  const getPatients = async () => {
    try {
      const response = await getAllCareTeamMemberList();
      setLoader(false);
      if (response.status === 200) {
        setMemberList(response?.data?.data);
        setFilterData(response?.data?.data);
      } else {
        console.log(response?.data || response.message);
      }
    } catch (error) {
      setLoader(false);
      error?.data?.data &&
        console.log(error?.data?.data || error.data?.message);
    }
  };

  const onMemberSearch = async (e) => {
    let searchWord = e.target.value;
    const result = memberList?.filter((value) => {
      if (value) {
        return value?.full_name
          ?.toLowerCase()
          ?.includes(searchWord?.toLowerCase());
      }
      return false
    });

    if (searchWord === "") {
      setFilterData(memberList);
    } else {
      setFilterData(result);
    }
  };

  const deleteMember = async (memberId) => {
    try {
      const response = await deleteMemberService(programId, memberId);
      if (response) {
        showToastSuccess(response?.data || "Member removed successfully.");
        getPatients();
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
    }
  };

  //   let handleSubmit = async (event) => {
  //     event.preventDefault();
  //     var parms = {};
  //     parms["EmailList"] = formValues;

  //     try {
  //       const response = await inviteMembers(parms);
  //       setAskLoader(false);
  //       if (response.status === 200) {
  //         updateProgram(response?.data?.data);
  //         showToastSuccess("Invite sent successfully");
  //         console.log(response.data.data, "response data");

  //         setFormValues([{ email: "", first_name: "", last_name: "" }]);
  //       } else {
  //         showToastError(
  //           response?.data || response.message || "Some error occurred"
  //         );
  //       }
  //     } catch (error) {
  //       setAskLoader(false);
  //       showToastError(
  //         error?.data?.data || error.data?.message || "Some error occurred"
  //       );
  //     }
  //   };

  let handleMember = async () => {
    var parms = {};
    parms["EmailList"] = selectedMembers.map((dt) => {
      return { name: dt.name, email: dt.email };
    });

    try {
      const response = await inviteMembers(parms);
      setAskLoader(false);
      if (response.status === 200) {
        // updateProgram(response?.data?.data);
        showToastSuccess("Invite sent successfully");

        setFormValues([{ email: "", first_name: "", last_name: "" }]);
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      setAskLoader(false);
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
    }
  };

  //   const renderModal = () => {
  //     return (
  //       <div
  //         classname="modal fade"
  //         id="memberModal"
  //         data-bs-backdrop="static"
  //         data-bs-keyboard="false"
  //         aria-labelledby="memberModalLabel"
  //         aria-hidden="true"
  //       >
  //         <div classname="modal-dialog">
  //           <div classname="modal-content">
  //             <div classname="modal-header p-4">
  //               {/* <h5 classname="modal-title" id="exampleModalLabel">Modal title</h5> */}
  //               <h5 className="mb-0">Add new members</h5>
  //               <button
  //                 type="button"
  //                 classname="btn-close"
  //                 data-bs-dismiss="modal"
  //                 aria-label="Close"
  //               ></button>
  //             </div>
  //             <div classname="modal-body pb-4 px-4">
  //               <h4 className="text-green mb-2">
  //                 {props.singleActiveProgram[0]?.programName}
  //               </h4>
  //               <p className="mb-5">
  //                 {props.singleActiveProgram[0]?.description}
  //               </p>
  //               <form onSubmit={handleSubmit}>
  //                 <div className="mb-1">
  //                   <div className="row mb-2">
  //                     <div className="col-md-5">
  //                       <label className="form-label" for="email">
  //                         Email Address<span className="text-danger"> *</span>
  //                       </label>
  //                     </div>
  //                     <div className="col-md-5">
  //                       <label className="form-label">
  //                         Name<span> (Optional)</span>
  //                       </label>
  //                     </div>
  //                   </div>
  //                   {formValues.map((element, index) => (
  //                     <div className="row" key={index}>
  //                       <div className="col-md-5">
  //                         {/* <label className="form-label">Email Address</label> */}
  //                         <input
  //                           className="form-control description_inputf mb-2"
  //                           type="email"
  //                           id="email"
  //                           name="email"
  //                           placeholder="e.g. sharonjames@gmail.com"
  //                           value={element.email || ""}
  //                           onChange={(e) => handleChange(index, e)}
  //                         />
  //                         {element.email !== "" &&
  //                         !validateEmail(element.email) ? (
  //                           <label className="text-danger m-1">
  //                             Email format is not valid.
  //                           </label>
  //                         ) : null}
  //                       </div>
  //                       <div className="col-md-5">
  //                         {/* <label className="form-label">Name</label> */}
  //                         <input
  //                           className="form-control description_inputf mb-2"
  //                           type="text"
  //                           name="first_name"
  //                           placeholder="e.g. Sharon James"
  //                           value={element.first_name || ""}
  //                           onChange={(e) => handleChange(index, e)}
  //                         />
  //                       </div>

  //                       <div className="col-md-2 d-flex align-items-center">
  //                         {index ? (
  //                           <button
  //                             type="button"
  //                             title="Remove"
  //                             className="btn btn-outline-danger px-2"
  //                             onClick={() => removeFormFields(index)}
  //                           >
  //                             <AiOutlineCloseCircle
  //                               style={{ marginTop: "-4px" }}
  //                               size="22px"
  //                             />
  //                           </button>
  //                         ) : null}
  //                       </div>
  //                     </div>
  //                   ))}
  //                 </div>
  //                 <div
  //                   className="btn-custom-link ms-0 mt-3 mb-5"
  //                   onClick={() => addFormFields()}
  //                 >
  //                   <AiOutlinePlus className="me-2" /> Add new
  //                 </div>
  //                 <hr className="mt-4 px-3" />
  //                 <div className="d-flex justify-content-between">
  //                   <button
  //                     type="button"
  //                     className="btn btn-outline-secondary px-4"
  //                     data-bs-dismiss="modal"
  //                   >
  //                     Cancel
  //                   </button>
  //                   <button
  //                     disabled={
  //                       formValues.filter((dt) => !validateEmail(dt.email))
  //                         .length > 0
  //                     }
  //                     className="btn btn-primary btn-custom"
  //                     type="submit"
  //                     data-bs-dismiss="modal"
  //                   >
  //                     Send Invitation
  //                   </button>
  //                 </div>
  //               </form>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     );
  //   };

  const renderSearchHeader = () => {
    const menuClass = `dropdown-menu${dropDownList ? " show" : ""}`;
    const drop = `dropdown-menu${dropDown ? " show" : ""}`;
    return (
      <div className="col-md-12 d-flex">
        <div className="w-50">
          <h4 className="headFont">Members</h4>
          <p className="resFont">Manage your program members here</p>
        </div>
        <div className="w-50 d-flex">
          <div className="actsearch_simple me-2">
            <FiSearch className="boxicon" />
            <input
              placeholder="Search for a member..."
              className="ms-2"
              onChange={(e) => onMemberSearch(e)}
            />
          </div>
          <div className="dropdown me-2">
            <button
              onBlur={() => {
                setDropDownList(false);
              }}
              onClick={() => {
                setDropDownList(!dropDownList);
                setDropDown(false);
              }}
              className="btn btn-custom-filter position-relative dropdown-toggle"
              type="button"
            >
               {sortBy === "atoz" ? 'Alphabetical' : sortBy === 'bydate' ? "Date" : "Filter"}
              <ul
                className={menuClass + " top-0 start-0 w-100"}
                style={{ marginTop: "3.5em" }}
              >
                <li>
                  <span
                    className="dropdown-item pointer"
                    onClick={() => {
                      nameSort(filterdata);
                      setSortBy('atoz')
                    }}
                  >
                    Alphabetical Order
                  </span>
                </li>
                <li>
                  <span
                    className="dropdown-item pointer"
                    onClick={() => {
                      dateSort(filterdata);
                      setSortBy('bydate')
                    }}
                  >
                    Date Order
                  </span>
                </li>
              </ul>
            </button>
          </div>
          <div className="dropdown me-2">
            <button
              onBlur={() => {
                setDropDown(false);
              }}
              onClick={() => {
                setDropDown(!dropDown);
                setDropDownList(false);
              }}
              className="btn btn-primary btn-custom position-relative dropdown-toggle"
              type="button"
            >
              <AiOutlinePlus className="me-2" /> Add new member
              <ul
                className={drop + " top-0 start-0 w-100"}
                style={{ marginTop: "3.5em" }}
              >
                {/* <li>
                  <a
                    className="dropdown-item pointer"
                    data-bs-toggle="modal"
                    data-bs-target="#memberModal"
                  >
                    Add new
                  </a>
                </li> */}
                <li>
                  <span
                    className="dropdown-item pointer"
                    onClick={() => setOpen(true)}
                    data-bs-toggle="modal"
                    data-bs-target="#addmembermodal1"
                  >
                    Add my client
                  </span>
                </li>
              </ul>
            </button>
          </div>
        </div>
        {/* {renderModal()} */}
        <AssignPatientModal
          programId={programId}
          selectedMembers={selectedMembers}
          addMember={() => handleMember()}
          open={open}
          setOpen={setOpen}
          members={memberList.map((dt) => dt?._id)}
          setMembers={setSelectedMembers}
        />

        <DeleteModal
          title={"Delete"}
          content1={"Are you sure you want to remove"}
          content2={"this member?"}
          modalId={"deleteMember"}
          button2={"No"}
          button1={"Yes"}
          onDelete={() => deleteMember(memberId)}
        />
      </div>
    );
  };

  const renderListRow = (item) => {
    return (
      <tr
        key={item?._id}
        className="pointer position-relative"
        onClick={() => {
          navigate("/allpatientinfo", {
            state: { user: item },
          });
        }}
      >
        <td className="text-muted avatar_warper position-static py-2 col-md-1"
        onMouseEnter={() => handleMouseEnter(item._id)}
        onMouseLeave={handleMouseLeave}
        >
          <SquareAvatar
            src={
              !urlPattern.test(item?.profilePicture)
                ? `${ApiConfig.ImageUrl}user/${item?._id}/${item?.profilePicture}`
                : item?.profilePicture
            }
            className="member_listimage squre_image2"
          />
          <AvatarPopover data={item} onHover={item._id === hoveredUserId}/>
        </td>
        <td className="text-muted py-2 col-md-2">
          {item?.full_name !== " " ? `${item?.full_name}` : "N/A"}
        </td>
        <td className="text-muted py-2 col-md-1">User</td>
        <td className="text-muted py-2 col-md-1">
          {item?.createdAt ? format(parseISO(item?.createdAt), "MMM d, yyyy") : null}
        </td>
        <td className="text-muted py-2 col-md-1">{item?.updatedAt ? format(parseISO(item?.updatedAt), "MMM d, yyyy") : '-'}</td>
        <td
          className="text-muted fw-bold py-2 col-md-1"
          style={{ cursor: "pointer" }}
        >
          {/* <span className="mb-0" data-bs-toggle="tooltip" data-bs-placement="top" title="Edit"><RiEdit2Fill size="1.5em" /></span> */}
          <span
            className="mb-0"
            data-bs-toggle="modal"
            data-bs-target="#deleteMember"
            title="View"
            onClick={(e) => {
              e.stopPropagation();
              setMemberId(item?._id?._id);
            }}
          >
            <MdDelete size="1.5em" />{" "}
          </span>
        </td>
      </tr>
    );
  };

  const renderList = () => {
    return (
      <tbody>
        {filterdata?.map((item) => {
          return renderListRow(item);
        })}
      </tbody>
    );
  };

  return (
    <>
      <Navbar />
      <div className="container-fluid mb-5">
        <div className="row">
          <div className="col-md-2">
            <Sidebar />
          </div>
          <div className="col-md-10 py-4 px-5">
            <nav aria-label="breadcrumb col-md-12">
              <ol class="breadcrumb">
                <li
                  class="breadcrumb-item cursor-pointer"
                  onClick={() => navigate("/")}
                >
                  Home
                </li>
                <li
                  class="breadcrumb-item active fw-bold pointer"
                  aria-current="page"
                  onClick={() => navigate(-1)}
                >
                  Care Team
                </li>
                <li
                  class="breadcrumb-item active fw-bold pointer"
                  aria-current="page"
                >
                  Member List
                </li>
              </ol>
            </nav>
            <div className="mt-4" style={{ height: "auto" }}>
              {renderSearchHeader()}
            </div>
            <div className="memlist_scroll_careTeam row me-0 ms-0 mt-4 spacing_scroll">
              {isLoading && (
                <Loader
                  visible={isLoading}
                  showBR={false}
                  emptyTextKey={"noAnyActiveMember"}
                />
              )}
              {!isLoading && (
                <table className="table table-hover ">
                  <thead>
                    <tr>
                      <td className="py-4">Photo</td>
                      <td className="py-4">Member Name</td>
                      <td className="py-4">Role</td>
                      <td className="py-4">Date Added</td>
                      <td className="py-4">Last Active</td>
                      <td className="py-4">Action</td>
                    </tr>
                  </thead>
                  {renderList()}
                </table>
              )}
            </div>
            {/* <div className="pb-4">
              <hr />
              <div className="d-flex justify-content-between">
                <div
                  text={"Back"}
                  style={{
                    cursor: "pointer",
                    backgroundColor: "#fff",
                    color: "black",
                    border: "1px solid #bbb9b9",
                    width: "120px",
                  }}
                  className="description_btnsave d-flex justify-content-center align-items-center"
                  onClick={() => !isLoading && props.onBack()}
                >
                  Back
                </div>
                <div
                  text={"Finish"}
                  style={{
                    cursor: "pointer",
                    backgroundColor: "rgba(31, 126, 120, 1)",
                    color: "white",
                    border: "1px solid #bbb9b9",
                    width: "120px",
                  }}
                  className="description_btnsave d-flex justify-content-center align-items-center"
                  onClick={() =>
                    !isLoading &&
                    showToastSuccess("Action Completed Succesfully.") &&
                    navigate("/activeprogramlist")
                  }
                >
                  Finish
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default TotalPatientList;
